<template>
  <div class="setup-hub-sidebar" v-if="isPanelOpen">
    <setup-hub-sidebar-header />
    <setup-hub-sidebar-content />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import SetupHubSidebarHeader from "@/components/setup-hub/sidebar/SetupHubSidebarHeader.vue";
import SetupHubSidebarContent from "@/components/setup-hub/sidebar/SetupHubSidebarContent.vue";
import { SidebarId, useSidebarPanelStore } from "@/_store/sidebar-panel.module.ts";

export default defineComponent({
  components: { SetupHubSidebarHeader, SetupHubSidebarContent },
  setup() {
    const sidebarPanelStore = useSidebarPanelStore();
    const isPanelOpen = computed(() => sidebarPanelStore.isOpen(SidebarId.SETUP_HUB));

    return {
      isPanelOpen,
    };
  },
});
</script>

<style scoped lang="scss">
.setup-hub-sidebar {
  margin-top: 18px;
  background-color: rgb(var(--v-theme-white));
  height: calc(100vh - 104px);
  border: 2px solid rgb(var(--v-theme-white));
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.icon-success-xs::before {
  color: rgb(var(--v-theme-green-light));
}

.icon-protection-xs::before {
  color: rgb(var(--v-theme-white));
}
</style>
